import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { SidebarDropdownMenuContent } from "@/components/layout/components/sidebar/SidebarDropdownMenuContent";
import { useProfileDropdownHandlers } from "@/components/layout/components/account-profile/useProfileDropdownHandlers";
import { useMemo } from "react";
import { PlanId } from "@/store/feature-gates/types";

export const SidebarDropdownMenu = observer(
  ({
    setIsImportModalOpen,
    onClick,
    className,
    displayAccountInfo,
  }: {
    setIsImportModalOpen: (b: boolean) => void;
    onClick?: () => void;
    className?: string;
    displayAccountInfo?: boolean;
  }) => {
    const { store } = useAppStore();

    const { syncState } = store.sync;
    const { profilePhotoUrl, profileDisplayName, profileEmailAddress } = store.account.myAccount;
    const { isPreloadingDisabled: isNoteContentPreloadingDisabled } = store.noteContentDocuments;
    const isDebugMode = store.debug.debugModeEnabled;

    const handlers = useProfileDropdownHandlers(onClick, setIsImportModalOpen);

    // Synchronous best-effort plan resolution
    const plan: PlanId | undefined = useMemo(
      () => store.subscriptions.personalPlanId,
      [store.subscriptions.personalPlanId]
    );

    return (
      <SidebarDropdownMenuContent
        className={className}
        isDebugMode={isDebugMode}
        syncInfo={{
          isNoteContentPreloadingDisabled,
          syncState,
        }}
        accountInfo={{
          profilePhotoUrl,
          profileDisplayName,
          profileEmailAddress,
          plan,
        }}
        displayAccountInfo={displayAccountInfo ?? false}
        handlers={handlers}
      />
    );
  }
);
